// External packages
import * as React from 'react';

// Components
import { MediaModal } from 'components/MediaModal';

// Types
import { Image } from '../../../../server/src/types';

// Utils
import { getBestImageUrl } from 'utils/getImageUrl';

type ImagePreviewModalProps = {
  modalTrigger?: React.ReactNode;
  image: Image;
  disableDelete?: boolean;
};

export const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  modalTrigger,
  image,
  disableDelete = false,
}) => (
  <MediaModal
    modalTrigger={modalTrigger}
    media={{ ...image, altText: image.altText ?? undefined }}
    fileType="images"
    disableDelete={disableDelete}
    renderMedia={({ altText }) => (
      <img
        className="max-h-[calc(100vh-9.5rem)] w-full h-full"
        src={getBestImageUrl(image, 'large')}
        alt={altText}
      />
    )}
  />
);
